/**
 * Configuration de l'API Backend - URL depuis .env
 * Change REACT_APP_API_URL dans .env pour les tests (local, ngrok, Cloud Run)
 */

const DEFAULT_URL = 'https://heya-backend-256564646069.europe-west1.run.app';
const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || DEFAULT_URL;

/**
 * Valide l'URL du backend pour prévenir les attaques SSRF
 */
const validateBackendUrl = (url) => {
  if (!url) return null;
  try {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol)) return null;
    
    if (process.env.NODE_ENV === 'production') {
      const isAllowed = 
        parsed.hostname === 'backend.heya.app' ||
        parsed.hostname.endsWith('.run.app') ||
        parsed.hostname.endsWith('.ngrok-free.app') ||
        parsed.hostname.endsWith('.ngrok.io');
      if (!isAllowed) {
        console.error('❌ [API] Domaine non autorisé:', parsed.hostname);
        return null;
      }
      if (parsed.protocol !== 'https:') return null;
    }
    
    return url;
  } catch {
    return null;
  }
};

const getBackendUrl = () => {
  const validated = validateBackendUrl(API_URL);
  return validated || DEFAULT_URL;
};

export const API_BASE_URL = getBackendUrl();

export const API_ENDPOINTS = {
  SEND_VERIFICATION_CODE: `${API_BASE_URL}/api/v1/auth/send-verification-code`,
  VERIFY_CODE: `${API_BASE_URL}/api/v1/auth/verify-code`,
  SEND_INSCRIPTION_CONFIRMATION: `${API_BASE_URL}/api/v1/auth/send-inscription-confirmation`,
};

export const fetchWithTimeout = async (url, options = {}, timeout = 15000) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
      headers: { 'Content-Type': 'application/json', ...options.headers },
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') throw new Error('La requête a expiré. Veuillez réessayer.');
    throw error;
  }
};

export const parseJsonResponse = async (response) => {
  const text = await response.text();
  if (!response.ok) {
    let msg = 'Une erreur est survenue';
    if (text) {
      try {
        const d = JSON.parse(text);
        msg = d.detail || d.message || msg;
      } catch {
        msg = text;
      }
    }
    throw new Error(msg);
  }
  if (!text) throw new Error('Réponse vide du serveur');
  try {
    return JSON.parse(text);
  } catch {
    throw new Error('Réponse invalide du serveur');
  }
};
